import React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useState } from "react";

export default function Photoupload() {
  const [btnLoading, setBtnLoading] = useState(false);

  return (
    <div className="text-start container text-black mt-5">
      <Form.Group controlId="formFile" className="mb-3">
        <Form.Label>Room Photos</Form.Label>
        <Form.Control type="file" />
      </Form.Group>

      <Form.Group controlId="formFile" className="mb-3">
        <Form.Label>Attached Washroom Photos</Form.Label>
        <Form.Control type="file" />
      </Form.Group>

      <Form.Group controlId="formFile" className="mb-3">
        <Form.Label>Common Room Photos</Form.Label>
        <Form.Control type="file" />
      </Form.Group>

      <Form.Group controlId="formFile" className="mb-3">
        <Form.Label>Building Photos</Form.Label>
        <Form.Control type="file" />
      </Form.Group>

      <div>
        <Button variant="outline-danger">
          {btnLoading ? "Submitting..." : "Submit"}
        </Button>
      </div>
    </div>
  );
}
